class ShippingVisibility {
    constructor() {
      this.shippingElement = document.querySelector('.cart-shipping');
      if (!this.shippingElement) return;
      
      this.init();
    }
  
    async init() {
      try {
        const response = await fetch(
          window.Shopify.routes.root + 'browsing_context_suggestions.json'
            + '?country[enabled]=true'
            + `&country[exclude]=${window.Shopify.country}`
        );
        
        const data = await response.json();
        
        // Get detected country from the response
        const detectedCountry = data.detected_values?.country?.handle || '';
        
        // Hide shipping info if country is not Germany (DE)
        if (detectedCountry !== 'DE') {
          this.shippingElement.style.setProperty('display', 'none', 'important');
        }
      } catch (error) {
        console.error('Error fetching country data:', error);
        // Hide shipping info by default if there's an error
        this.shippingElement.style.setProperty('display', 'none', 'important');
      }
    }
  }
  
  // Initialize when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    new ShippingVisibility();
  });
  
  // Re-initialize when Shopify sections are reloaded
  document.addEventListener('shopify:section:load', () => {
    new ShippingVisibility();
  });